import {
  formatPriceChange,
  formatRatingsChange,
  formatUpsideDownside,
  getCellStatusBackgroundByActionCompany,
  getCellStatusClassRules,
  getValueBgClass,
} from '../../lib/utils';
import { getPriceTarget, getPriorPriceTarget } from '@benzinga/calendar-manager';
import { DateTime } from 'luxon';
import { ColDef } from 'ag-grid-community';

export const AnalystRating = [
  {
    cellStyle: { fontWeight: 'bold' },
    field: 'date',
    headerName: 'Date',
    initialSort: 'desc' as ColDef['initialSort'],
    valueFormatter: ({ value }: any) => DateTime.fromISO(value).toFormat('MM/dd/yyyy'),
    width: 85,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellStyle: { fontWeight: 'bold' },
    field: 'ticker',
    headerName: 'Ticker',
    width: 60,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellRendererParams: {
      tickerLogoVisible: true,
    },
    cellStyle: { fontWeight: 'bold' },
    field: 'name',
    width: 200,
  },
  {
    cellClass: ({ data }: any) => getCellStatusClassRules(data.action_pt),
    cellStyle: { textAlign: 'left' },
    field: 'pt_prior',
    headerName: 'Price Target',
    valueFormatter: ({ data }: any) => formatPriceChange(getPriorPriceTarget(data), getPriceTarget(data)),
    valueGetter: ({ data }: any) => (getPriceTarget(data) ? Number(getPriceTarget(data)) : null),
    width: 105,
  },
  {
    cellClass: ({ value }: any) => getValueBgClass(value),
    cellStyle: { textAlign: 'left' },
    field: 'upside_downside',
    headerName: 'Upside/Downside',
    valueFormatter: ({ value }: any) => (value ? `${value}%` : '—'),
    valueGetter: ({ data }: any) => formatUpsideDownside(data?.quote?.last, getPriceTarget(data)),
    width: 120,
  },
  {
    cellClass: ({ data }: any) => getCellStatusBackgroundByActionCompany(data.action_company),
    cellStyle: { textAlign: 'left' },
    field: 'rating_current',
    headerName: 'Recommendation',
    valueFormatter: ({ data }: any) => formatRatingsChange(data.rating_prior, data.rating_current, data.action_company),
    width: 180,
  },
  {
    cellClass: 'ticker-cell',
    field: 'analyst',
    headerName: 'Firm',
    width: 120,
  },
] as ColDef[];
